import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { request } from '@/api/request';
import { mergeMutationOptions, type MutationOptions } from '@/modules/query/utils';
import type { Connection } from '@@/packages/shared/types/models/connection';
import { SUPPLIER_ASSESSMENT_NOTES_QUERY } from './queryKeys';

export function useSetClientNotes(
  options?: MutationOptions<
    Connection,
    {
      connectionID: string;
      supplierID: string;
      controlID: string;
      productID?: string;
      notes: string;
    }
  >,
) {
  const queryClient = useQueryClient();

  return useMutation(
    mergeMutationOptions(options, {
      async mutationFn(clientNoteUpdate) {
        const res = await request(
          'PUT',
          `/client-answer-notes/${clientNoteUpdate.connectionID}/${clientNoteUpdate.controlID}`,
          {
            notes: clientNoteUpdate.notes,
            productID: clientNoteUpdate.productID,
          },
        );
        return res.data;
      },
      async onSuccess(_data, { supplierID }) {
        await queryClient.invalidateQueries({
          queryKey: [SUPPLIER_ASSESSMENT_NOTES_QUERY, supplierID],
        });
      },
    }),
  );
}
